// extracted by mini-css-extract-plugin
export default {"root":"ReportItem_root__fw4UU","year":"ReportItem_year__xRDEB"};